import { Box } from '@mui/material';

export type ResponseTimeMeasurement = 'Ø2_visborger' | 'T1_2_vissag' | 'RowWithDetail' | 'FM_vishold' | 'FM_vislektion';

// Misspelled on purpose: the external response time measurement looks for exactly this name
export function responseTimeMeasurement(measurement: ResponseTimeMeasurement) {
  return { 'data-responsetimemeasurment': measurement };
}

interface IResponseTimeMarker {
  measurement: ResponseTimeMeasurement;
  isReady: boolean;
}

export function ResponseTimeMarker({ measurement, isReady }: IResponseTimeMarker) {
  if (!isReady) {
    return null;
  }

  return <Box data-responsetimemeasurment={measurement} />;
}
